import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import ProductsSection from '../components/ProductsSection';
import TortenSection from '../components/TortenSection';
import ReviewsSection from '../components/ReviewsSection';
import OpeningHoursSection from '../components/OpeningHoursSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import MobileBottomBar from '../components/MobileBottomBar';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#f7f5f2]">
      <Helmet>
        <title>Cafe Konditorei Rieppel | Wiener Bäckerei & Konditorei seit 1938 | 1150 Wien</title>
        <meta name="description" content="Ihre Naturbackstube in Wien Rudolfsheim-Fünfhaus. Seit 1938 Wiener Backtradition – frisches Brot, Gebäck & Torten, handgemacht ohne Zusatzstoffe. 365 Tage geöffnet." />
        <link rel="canonical" href="https://rieppel-baeckerei.at/" />
      </Helmet>
      <Header />
      <main className="pb-20 lg:pb-0">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProductsSection />
        <TortenSection />
        <ReviewsSection />
        <OpeningHoursSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
};

export default HomePage;
